import React from 'react';
import { connect } from 'react-redux';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import List from 'components/List';

import Loader from 'components/layout/Loader';
import {Link} from "react-router-dom";
import TableResponsive from "../layout/TableResponsive";
import ClientListInfo from "../layout/ClientListInfo";
import {deleterDispatchHelper} from "../../actions/DeleterActions";
import SimplePrompt from "../layout/SimplePrompt";
import {Button} from "react-bootstrap";

class Users extends React.Component {
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  handleRemoveClick = (e, userId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteUser } = this.props;
    deleteUser(userId);
  };
  render() {
    const {
      intl: { messages },
      show,
      close,
      urlData,
      list,
      appIntl
    } = this.props;
    const headers = {
      user: messages.user,
      actions: messages.actions,
    };
    const rows = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const detailsUrl = appIntl.urlPrefix + 'account/settings/users/' + list.data.list[i].username;
      const rowData = {
        client: <ClientListInfo client={list.data.list[i]} />,
        actions: [
          <Button href={detailsUrl} className="btn-default">
            <i className="fa fa-pencil-alt" /> {messages.edit}
          </Button>,
          <SimplePrompt className="m-b-0" onSuccess={e => this.handleRemoveClick(e, list.data.list[i].username)} />
        ],
      };

      rows.push(rowData);
    }
    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.users}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            listName="users"
            url="/api/clients.json"
            urlData={urlData}
            list={list}
            sortOptions={['cdate,desc']}
          >
            <div class="panel panel-transparent">
              <div class="panel-body no-padding">
                {list.pending ? <Loader /> : <TableResponsive headers={headers} rows={rows} hover />}
              </div>
            </div>
          </List>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.list.users,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteUser: userId => {
      deleterDispatchHelper('user', '/api/clients/' + userId + '.json', dispatch);
    },
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Users));
